import React, { useEffect, useState } from "react";
import { fetchAdminJson } from "../settingsHelpers";

const FILTERS = [
  { value: "", label: "All" },
  { value: "sent", label: "Sent" },
  { value: "pending", label: "Pending" },
  { value: "failed", label: "Failed" },
];

const EVENTS = ["", "QualifiedLead", "SignUp", "Purchase", "Closed"];

function formatDate(value) {
  return value ? new Date(value).toLocaleString() : "-";
}

function SummaryMetric({ label, value, tone }) {
  return (
    <div style={{ border: "1px solid var(--border)", borderTop: `3px solid ${tone}`, minWidth: 130, padding: "10px 12px" }}>
      <div style={{ color: "var(--text-secondary)", fontSize: 11, fontWeight: 600, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, marginTop: 3 }}>{value}</div>
    </div>
  );
}

export function MetaCapiTab() {
  const [payload, setPayload] = useState({ summary: {}, events: [] });
  const [status, setStatus] = useState("");
  const [eventName, setEventName] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async (filters = {}) => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams();
      const selectedStatus = filters.status ?? status;
      const selectedEvent = filters.eventName ?? eventName;
      const selectedSearch = filters.search ?? search;
      if (selectedStatus) params.set("status", selectedStatus);
      if (selectedEvent) params.set("event_name", selectedEvent);
      if (selectedSearch.trim()) params.set("q", selectedSearch.trim());
      const suffix = params.toString() ? `?${params}` : "";
      setPayload(await fetchAdminJson(`/api/crm/admin/meta-capi-events/${suffix}`));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load({ status: "", eventName: "", search: "" }); }, []);

  const selectFilter = (value) => {
    setStatus(value);
    load({ status: value });
  };

  const submitSearch = (event) => {
    event.preventDefault();
    load();
  };

  return (
    <div className="settings-stack">
      {error && <div className="message-banner error">{error}</div>}
      <div className="settings-card settings-table-card">
        <div className="settings-card-header">
          <div>
            <p className="login-kicker">Meta Conversions API</p>
            <h3>Event Deliveries</h3>
          </div>
          <button type="button" className="secondary-ghost compact-button" onClick={() => load()} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh"}
          </button>
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", padding: "0 0 16px" }}>
          <SummaryMetric label="Live deliveries" value={(payload.summary?.sent || 0) + (payload.summary?.pending || 0) + (payload.summary?.failed || 0)} tone="#2563eb" />
          <SummaryMetric label="Sent" value={payload.summary?.sent || 0} tone="#16a34a" />
          <SummaryMetric label="Pending" value={payload.summary?.pending || 0} tone="#d97706" />
          <SummaryMetric label="Failed" value={payload.summary?.failed || 0} tone="#dc2626" />
        </div>
        <form onSubmit={submitSearch} style={{ display: "grid", gridTemplateColumns: "minmax(220px, 1fr) minmax(170px, 220px) auto", gap: 10, padding: "0 0 16px" }}>
          <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search Lead ID, lead name, or Meta lead ID" aria-label="Search Meta CAPI deliveries" />
          <select value={eventName} onChange={(event) => { setEventName(event.target.value); load({ eventName: event.target.value }); }} aria-label="Filter by Meta event">
            {EVENTS.map((value) => <option key={value} value={value}>{value || "All event types"}</option>)}
          </select>
          <button type="submit" className="primary-button" disabled={loading}>Search</button>
        </form>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", padding: "0 0 16px" }}>
          {FILTERS.map((filter) => (
            <button key={filter.value} type="button" className={`report-tab-button ${status === filter.value ? "active" : ""}`} onClick={() => selectFilter(filter.value)}>
              {filter.label} {filter.value ? `(${payload.summary?.[filter.value] || 0})` : `(${(payload.summary?.sent || 0) + (payload.summary?.pending || 0) + (payload.summary?.failed || 0)})`}
            </button>
          ))}
        </div>
        {loading ? <p style={{ padding: 16, color: "var(--text-secondary)" }}>Loading delivery records...</p> : (
          <div className="table-scroll report-table-scroll">
            <table className="report-table">
              <thead><tr><th>Created</th><th>Lead</th><th>Meta Lead ID</th><th>Event</th><th>Status</th><th>Attempts</th><th>Sent</th><th>Error</th></tr></thead>
              <tbody>
                {!payload.events?.length ? <tr><td colSpan={8} style={{ textAlign: "center", padding: 24 }}>No delivery records match this filter.</td></tr> : payload.events.map((event) => (
                  <tr key={event.id}>
                    <td style={{ whiteSpace: "nowrap" }}>{formatDate(event.created_at)}</td>
                    <td><strong>{event.client_id}</strong><br /><span style={{ color: "var(--text-secondary)", fontSize: 12 }}>{event.lead_name}</span></td>
                    <td><code>{event.leadgen_id || "-"}</code></td>
                    <td>{event.event_name}</td>
                    <td><span className={`agent-badge ${event.status === "sent" ? "mint" : ""}`} style={event.status === "failed" ? { background: "#fef2f2", color: "#b91c1c", border: "1px solid #fecaca" } : {}}>{event.status}</span></td>
                    <td>{event.attempts}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{formatDate(event.sent_at)}</td>
                    <td title={event.last_error || ""} style={{ maxWidth: 240, color: event.last_error ? "#b91c1c" : "var(--text-secondary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{event.last_error || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default MetaCapiTab;
